import appConstants from '../../../../../../../../../constants';
import { KEYS } from '../../../../../../../../../l18n/constants';
import CCFormDropdown from '../../../../../../../../libs/CiscoCore/Form/Dropdown';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { useScreenContext } from '../../../../../../../ContextProvider/Screen';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';

const constants = Object.freeze({
  CLASSNAME_BASE: 'grid grid-cols-1 xs:grid-cols-3 gap-4 xs:gap-5 sm:gap-6'
});

function getComputedDropdownSize(useLargeDropdown) {
  return useLargeDropdown ? 'large':'medium';
}

function getComputedPartnerSpecializationDropdownLabel(selectedPartnerRoleCode, getTranslationFor) {
  if (!!selectedPartnerRoleCode) {
    switch (selectedPartnerRoleCode) {
      case appConstants.VALUE_INTEGRATOR:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION);
      case appConstants.VALUE_PROVIDER:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE);
      default:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE);
    }
  }
  else return getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE);
}

function getComputedPartnerSpecializationDropdownPlaceholderText(selectedPartnerRoleCode, getTranslationFor) {
  if (!!selectedPartnerRoleCode) {
    switch (selectedPartnerRoleCode) {
      case appConstants.VALUE_INTEGRATOR:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_);
      case appConstants.VALUE_PROVIDER:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_);
      default:
        return '';//getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S);
    }
  }
  else return getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S);
}

export default function FilterByNeedForm( { className} ) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const { isScreenMDAndUp } = useScreenContext();
  const computedDropdownSize = getComputedDropdownSize(isScreenMDAndUp);
  const {
    isFilterLoadingInProgress,
    filterLoadingError,
    partnerRoleFilterValues,
    isPartnerRoleFilterDropdownOpened,
    togglePartnerRoleFilterDropdown,
    selectPartnerRoleFilterValue,
    selectedPartnerRoleCode,

    partnerLevelFilterValues,
    isPartnerLevelFilterDropdownOpened,
    togglePartnerLevelFilterDropdown,
    togglePartnerLevelFilterValue,

    partnerExpertiseFilterValues,
    isPartnerExpertiseFilterDropdownOpened,
    togglePartnerExpertiseFilterDropdown,
    togglePartnerExpertiseFilterValue,


  } = usePartnerSearchContext();

  const computedPartnerSpecializationDropdownLabel = getComputedPartnerSpecializationDropdownLabel(selectedPartnerRoleCode, getTranslationFor);
  const computedPartnerSpecializationDropdownPlaceholderText = getComputedPartnerSpecializationDropdownPlaceholderText(selectedPartnerRoleCode, getTranslationFor);

  //const computedShowPartnerRoleDescriptionClick = handleClick(togglePartnerRoleDescriptionFn)

  return (
    <div className={computedClassName}>
      <div>
        <span className="flex items-center text-cc-body-medium sm:text-cc-body-large font-normal mb-2 md:mb-2.5"><span>{getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_ROLE)}</span></span>
        <CCFormDropdown placeholderText={getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE)}
                        isDisabled={isFilterLoadingInProgress}
                        hasError={!!filterLoadingError}
                        isProcessingInProgress={isFilterLoadingInProgress}
                        isOpened={isPartnerRoleFilterDropdownOpened}
                        openFn={togglePartnerRoleFilterDropdown}
                        closeFn={togglePartnerRoleFilterDropdown}
                        size={computedDropdownSize}
                        optionList={partnerRoleFilterValues}
                        optionKeyIsDisabled={appConstants.KEY_IS_DISABLED}
                        optionKeyIsSelected={appConstants.KEY_IS_SELECTED}
                        optionKeyLabel={appConstants.KEY_NAME}
                        optionKeyValue={appConstants.KEY_CODE}
                        optionSelectFn={selectPartnerRoleFilterValue}
                        inline={false}/>
      </div>

      <div>
        <span className="flex items-center text-cc-body-medium sm:text-cc-body-large font-normal mb-2 md:mb-2.5"><span>{getTranslationFor(KEYS.L18N_KEY_LABEL_PARTNER_LEVEL)}</span></span>
        <CCFormDropdown placeholderText={getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_)}
                        isDisabled={!selectedPartnerRoleCode}
                        hasError={!!filterLoadingError}
                        isProcessingInProgress={isFilterLoadingInProgress}
                        isOpened={isPartnerLevelFilterDropdownOpened}
                        openFn={togglePartnerLevelFilterDropdown}
                        closeFn={togglePartnerLevelFilterDropdown}
                        size={computedDropdownSize}
                        optionList={partnerLevelFilterValues}
                        optionKeyIsDisabled={appConstants.KEY_IS_DISABLED}
                        optionKeyIsSelected={appConstants.KEY_IS_SELECTED}
                        optionKeyLabel={appConstants.KEY_NAME}
                        optionKeyValue={appConstants.KEY_CODE}
                        allowMultipleSelection={true}
                        optionSelectFn={togglePartnerLevelFilterValue}
                        optionUnselectFn={togglePartnerLevelFilterValue}
                        inline={false}/>
      </div>

      <div>
        <span className="flex items-center text-cc-body-medium sm:text-cc-body-large font-normal mb-2 md:mb-2.5"><span>{computedPartnerSpecializationDropdownLabel}</span></span>
        <CCFormDropdown placeholderText={computedPartnerSpecializationDropdownPlaceholderText}
                        isDisabled={!selectedPartnerRoleCode || [appConstants.VALUE_DEVELOPER, appConstants.VALUE_ADVISOR].includes(selectedPartnerRoleCode)}
                        isProcessingInProgress={isFilterLoadingInProgress}
                        hasError={!!filterLoadingError}
                        isOpened={isPartnerExpertiseFilterDropdownOpened}
                        openFn={togglePartnerExpertiseFilterDropdown}
                        closeFn={togglePartnerExpertiseFilterDropdown}
                        size={computedDropdownSize}
                        optionList={partnerExpertiseFilterValues}
                        optionKeyIsDisabled={appConstants.KEY_IS_DISABLED}
                        optionKeyIsSelected={appConstants.KEY_IS_SELECTED}
                        optionKeyLabel={appConstants.KEY_NAME}
                        optionKeyValue={appConstants.KEY_CODE}
                        allowMultipleSelection={true}
                        optionSelectFn={togglePartnerExpertiseFilterValue}
                        optionUnselectFn={togglePartnerExpertiseFilterValue}
                        inline={false}/>
      </div>
    </div>
  );

}

// <button type="button" className="appearance-none ml-2.5"><CCIconInfoSolid16x16 aria-hidden="true"/></button>
// <button type="button" className="appearance-none ml-2.5"><CCIconInfoSolid16x16 aria-hidden="true"/></button>
// <button type="button" className="appearance-none ml-2.5"><CCIconInfoSolid16x16 aria-hidden="true"/></button>
